export enum UserProfiles {
    PREPARATEUR = "MAG",
    CHAUFFEUR = "CHAUF",
    PREPARATEUR_CHAUFFEUR = "MAGCHAUF",
    VEGA = "VEGA",
}
